
import { IngredientGroups, Ingredients, UnitGrams } from '@/entity/entity'
import IngredientForm from '@/component/IngredientForm.vue'
import Vue from 'vue'
export default Vue.extend({
  name: 'AddIngredient',
  props: {
    addedIngredients: {
      type: Array,
      required: true
    },
    ingredients: {
      type: Object as () => Ingredients,
      required: true
    },
    ingredientGroups: {
      type: Object as () => IngredientGroups,
      required: true
    },
    unitGrams: {
      type: Object as () => UnitGrams,
      required: true
    }
  },
  data: function () : {
    step: 1 | 2 | 3,
    ingredientId: string,
    ingredientGroupId: string,
    grams: number,
    origin: string
    } {
    return {
      step: 1,
      ingredientId: '',
      ingredientGroupId: '',
      grams: 0,
      origin: ''
    }
  },
  components: {
    IngredientForm: IngredientForm
  },
  computed: {
    ingredientList: function () : {id: string, name: string}[] | null {
      if (this.ingredientGroupId === '') return null
      const res : {id: string, name: string}[] = []
      for (const key in this.ingredients) {
        if (this.ingredients[key].groupId === this.ingredientGroupId && this.addedIngredients.indexOf(key) === -1) {
          res.push({
            id: key,
            name: this.ingredients[key].name
          })
        }
      }
      return res.concat([])
    }
  },
  methods: {
    chooseFoodGroup: function (id: string) {
      if (!this.ingredientGroups[id]) return
      this.ingredientGroupId = id
      this.step = 2
    },
    backToStepChooseFoodGroup: function () {
      this.step = 1
    },
    chooseFood: function (id: string) {
      if (!this.ingredients[id]) return
      this.ingredientId = id
      this.step = 3
    },
    backToStepChooseFood: function () {
      this.step = 2
    },
    ingredientFormUpdated: function (e : {grams: number, origin: string}) {
      this.grams = e.grams
      this.origin = e.origin
    },
    saveIngredient: function (e: MouseEvent) {
      e.preventDefault()
      this.$emit('save', {
        id: this.ingredientId,
        name: this.ingredients[this.ingredientId].name,
        grams: this.grams,
        origin: this.origin
      })
    },
    emitClose: function () {
      this.$emit('close')
    },
    emitSave: function () {
      this.$emit('save', {
        id: this.ingredientId,
        name: this.ingredients[this.ingredientId].name,
        grams: this.grams,
        origin: this.origin
      })
    }
  }
})
